import { render, staticRenderFns } from "./AppColorPalette.vue?vue&type=template&id=45e716e2&scoped=true&"
import script from "./AppColorPalette.vue?vue&type=script&lang=js&"
export * from "./AppColorPalette.vue?vue&type=script&lang=js&"
import style0 from "./AppColorPalette.vue?vue&type=style&index=0&id=45e716e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e716e2",
  null
  
)

export default component.exports